import {BehaviorSubject, Observable, of} from 'rxjs';
import {catchError, concatMap, finalize, tap} from 'rxjs/operators';

export abstract class InitLoaders {

    private loadingSubjects = {};

    showLoaderUntilCompleted<T>(obs$: Observable<T>, func: string): Observable<T> {
        this.loadingSubjects[func] = new BehaviorSubject<boolean>(false);
        this.loadingOn(func);
        return of(null)
            .pipe(
                tap(() => this.loadingOn(func)),
                concatMap(() => obs$),
                catchError(err => {
                    this.loadingOff(func);
                    throw err;
                }),
                finalize(() => this.loadingOff(func))
            );
    }

    loading$(func: string[]): Observable<boolean> {
        // console.log('get', func)
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < func.length; i++) {
            if (this.loadingSubjects[func[i]]) {
                return this.loadingSubjects[func[i]].asObservable();
            }
        }

    }

    loadingOn(func) {
        // console.log('strart', func);
        if (this.loadingSubjects[func]) {
            this.loadingSubjects[func].next(true);
        } else {
            this.loadingSubjects[func] = new BehaviorSubject<boolean>(false);
            this.loadingSubjects[func].next(true);
        }
    }

    loadingOff(func) {
        // console.log('finish', func);
        this.loadingSubjects[func].next(false);
    }
}
